"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_onclickoutside_1 = __importDefault(require("react-onclickoutside"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_style_proptype_1 = __importDefault(require("react-style-proptype"));
const emotion_1 = require("emotion");
const utils_1 = require("./utils");
const BlockButton_1 = __importDefault(require("./Utilities/BlockButton"));
const DEFAULT = 'default';
const SIMPLE = 'simple';
const NAVTAB = 'navtab';
class Dropdown extends react_1.Component {
    constructor() {
        super(...arguments);
        this.state = {
            open: false,
        };
        this.toggle = () => {
            this.setState(prevState => ({ open: !prevState.open }));
        };
    }
    handleClickOutside() {
        this.state.open && this.setState({ open: false });
    }
    render() {
        const { open } = this.state;
        const _a = this.props, { title, children, className, style, disabled, type, variant } = _a, rest = __rest(_a, ["title", "children", "className", "style", "disabled", "type", "variant"]);
        let { as: AsComponent } = this.props;
        let InnerAsComponent = 'button';
        if ((variant || type) === NAVTAB) {
            AsComponent = 'li';
            InnerAsComponent = 'a';
        }
        const innerClassName = emotion_1.cx('btn', {
            'btn-default dropdown-toggle': (variant || type || DEFAULT) === DEFAULT,
            'btn-link': (variant || type) === SIMPLE,
            clickable: (variant || type) === NAVTAB,
        });
        const { eventTypes, outsideClickIgnoreClass, preventDefault, stopPropagation, disableOnClickOutside, enableOnClickOutside } = rest, restProps = __rest(rest, ["eventTypes", "outsideClickIgnoreClass", "preventDefault", "stopPropagation", "disableOnClickOutside", "enableOnClickOutside"]);
        return (react_1.default.createElement(AsComponent, Object.assign({ className: emotion_1.cx('dropdown', className, { open }), style: style }, restProps),
            react_1.default.createElement(InnerAsComponent, { disabled: !children || !react_1.default.Children.count(children) || disabled, onClick: this.toggle, className: innerClassName },
                title,
                " ",
                ((variant || type || DEFAULT) === DEFAULT || (variant || type) === NAVTAB) && react_1.default.createElement("span", { className: "caret" })),
            react_1.default.createElement(BlockButton_1.default, { tabIndex: "-1", className: "dropdown-menu", as: "ul", onClick: this.toggle }, react_1.default.Children.map(children, child => {
                if (!child) {
                    return null;
                }
                if (child.type === 'hr') {
                    return react_1.default.createElement("li", { className: "divider", key: child.key });
                }
                return (react_1.default.createElement(BlockButton_1.default, { tabIndex: "-1", as: 'li', className: emotion_1.cx('dropdown-item', { disabled: child.props.disabled }), key: child.key, onClick: child.props.disabled ? e => e.stopPropagation() : undefined }, child));
            }))));
    }
}
Dropdown.propTypes = {
    as: prop_types_1.default.string,
    variant: prop_types_1.default.oneOf([DEFAULT, SIMPLE, NAVTAB]),
    children: prop_types_1.default.node,
    title: prop_types_1.default.node,
    className: prop_types_1.default.string,
    style: react_style_proptype_1.default,
    disabled: prop_types_1.default.bool,
    type: utils_1.deprecatedProp(prop_types_1.default.oneOf([DEFAULT, SIMPLE, NAVTAB]), 'Use `variant` instead.'),
};
Dropdown.defaultProps = {
    as: 'div',
    disabled: false,
    className: '',
};
exports.default = react_onclickoutside_1.default(Dropdown);
